@if (currentUserIsSpecial) {
  <app-my-referrals-my-info-special />
} @else {
  <app-my-referrals-my-info-default />
}
